import React from 'react';
import moment from 'moment';

import { DatePickerField, SearchTextField, MCButton, View } from 'src/components/basic';
import { popupModel, TableLibrary } from 'src/components/complex';
import BaseComponent from 'src/components/BaseComponent';
import ShortInfo from 'src/components/user/ShortInfo';
import AlertManager from 'src/components/alert';

import { BASE_ICONS } from 'src/components/svg';

import config from 'src/config';

import { withRouter, remCss, number, lang, upperFirstChar, permissions } from 'src/helpers';

import model from './model';
import AddInvoice from './AddInvoice';
import DetailInvoice from './DetailInvoice';
import constants from 'src/constants';
import LANG_CONST from 'src/helpers/lang/const';

const { ACTIONS } = permissions;

class Invoices extends BaseComponent {
  componentDidMount() {
    model.setStateSilent({ pageIndex: 0 });
    model.subscribe(this.subscription);

    let invoiceId =
      this.props.router.location.state?.invoiceId || this.props.router.params.invoiceId;

    if (invoiceId) {
      popupModel.setActivePopup('invoice_detail', {
        active: true,
        component: DetailInvoice,
        props: {
          item: { id: this.props.router.location.state?.invoiceId }
        }
      });
    }
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
  }

  returnActions = (item) => {
    let validTime = true;
    if (config.get('refundTime') && item.paidDate) {
      const time = moment().valueOf() - moment(item.paidDate).valueOf();
      validTime = time <= config.get('refundTime');
    }
    let showDownloadIcon = true;
    let showEyeIcon = item.status === constants.general.invoiceStatus.paid;
    let showPayNow =
      !model.user.isDoctor &&
      !model.user.isClinic &&
      item.status === constants.general.invoiceStatus.unpaid;
    const medium = !this.props.screenDetail?.isLargeScreen;

    return (
      <View style={{ flexDirection: 'row' }}>
        <View style={{ flex: 1 }}>
          {medium &&
            item?.invoiceDate &&
            moment(item.invoiceDate, 'YYYYMMDD').format(
              `[${lang.t(LANG_CONST.date)}: ]DD - MMM - YYYY`
            )}
        </View>
        <div className={'mc-flex'} style={{ justifyContent: 'flex-end' }}>
          {!model.user.isPatient &&
            item.status === constants.general.invoiceStatus.paid &&
            validTime && (
              <MCButton
                onClick={() => {
                  AlertManager.popup(AlertManager.TYPES.WARN, {
                    close: false,
                    maxWidth: 500,
                    title: LANG_CONST.notice.refund_invoice,
                    cancelButton: {
                      label: LANG_CONST.buttons.cancel,
                      action: (actions) => actions.hide()
                    },
                    actionButton: {
                      label: LANG_CONST.buttons.confirm_refund,
                      action: (actions) => {
                        actions.setLoading(true);
                        model.refund(item, (err) => {
                          actions.hide();
                          actions.setLoading(false);
                          if (err) {
                            AlertManager.popup(AlertManager.TYPES.WARN, {
                              close: false,
                              title: err,
                              cancelButton: {
                                label: LANG_CONST.buttons.close,
                                action: (actions) => actions.hide()
                              }
                            });
                          }
                        });
                      }
                    }
                  });
                }}
                primary
                light
                padding={5}
                radius
                fillOpacity={'0.5'}
                label={LANG_CONST.buttons.refund}
              />
            )}
          {showEyeIcon && (
            <MCButton
              onClick={() => {
                popupModel.setActivePopup('invoice_detail', {
                  active: true,
                  component: DetailInvoice,
                  props: {
                    item
                  }
                });
              }}
              // iconname={BASE_ICONS.EYE_FILL}
              label={LANG_CONST.buttons.view}
              style={{ opacity: 0.5 }}
              width={42}
              dark
              padding={5}
              radius
              fillOpacity={'0.5'}
            />
          )}
          {showPayNow && (
            <MCButton
              primary
              dark
              radius
              medium
              type={'button'}
              onClick={() => {
                this.navigate(permissions.PAGES.INVOICES_PAYMENT_PAGE.match(item.id));
              }}
              label={LANG_CONST.buttons.pay_now}
            />
          )}
          {showDownloadIcon && (
            <MCButton
              type={'button'}
              onClick={() => model.openPdf(item)}
              iconname={BASE_ICONS.DOWNLOAD2}
              // iconname={'download-icon'}
              // fillOpacity={'0.5'}
              padding={0}
              // viewSize={42}
              width={42}
              dark
              radius
            />
          )}
        </div>
      </View>
    );
  };

  render() {
    let loading = model.refreshing();
    let noResults = model.noResults();
    let searchQuery = model.listInput('search');
    let items = model.items();
    let { total = 0 } = model.getCurrent();
    let columns;
    const medium = !this.props.screenDetail?.isLargeScreen;

    if (!model.state.user?.isClinic)
      columns = [
        {
          label: LANG_CONST.name,
          sort: { sortKey: model.state.user?.isPatient ? 'doctor' : 'patient' },
          resize: true,
          renderCell: (item) => {
            const partner = item.patientId !== model.state.user?.id ? item.patient : item.doctor;

            return (
              partner && (
                <ShortInfo
                  user={partner}
                  to={permissions.profilePath(partner)}
                  specialist={partner?.isDoctor ? partner.specialist : []}
                />
              )
            );
          }
        },

        !medium && {
          label: LANG_CONST.date,
          resize: true,
          sort: { sortKey: 'invoiceDate' },
          renderCell: (item) => {
            if (!item?.invoiceDate) {
              return null;
            }
            let date = moment(item.invoiceDate, 'YYYYMMDD');
            return date.format('DD - MMM - YYYY');
          }
        },
        {
          label: LANG_CONST.serie_invoice,
          sort: { sortKey: 'serieInvoiceNo' },
          resize: true,
          width: `${remCss(160)}px`,
          renderCell: (item) => item.serieInvoiceNo
        },
        {
          label: LANG_CONST.status,
          resize: true,
          width: `${remCss(130)}px`,
          sort: { sortKey: 'status' },
          renderCell: (item) => (
            <button className={'mc-status-' + item.status}>{upperFirstChar(item.status)}</button>
          )
        },
        {
          label: LANG_CONST.amount,
          sort: { sortKey: 'amount' },
          resize: true,
          width: `${remCss(160)}px`,
          renderCell: (item) => `${number.format(item.amount || 0)} ${item.currency}`
        },
        !medium && {
          label: LANG_CONST.actions,
          cellStyles: { textAlign: 'end' },
          width: `${remCss(245)}px`,
          renderCell: this.returnActions
        }
      ];
    else
      columns = [
        {
          label: LANG_CONST.serie_invoice,
          sort: { sortKey: 'serieInvoiceNo' },
          resize: true,
          width: `${remCss(160)}px`,
          renderCell: (item) => item.serieInvoiceNo
        },
        {
          label: LANG_CONST.patients,
          sort: { sortKey: 'patient' },
          resize: true,
          renderCell: (item) => {
            const partner = item.patient;
            return (
              partner && (
                <ShortInfo user={partner} to={permissions.profilePath(partner)} specialist={[]} />
              )
            );
          }
        },

        !medium && {
          label: LANG_CONST.date,
          resize: true,
          sort: { sortKey: 'invoiceDate' },
          renderCell: (item) => {
            if (!item?.invoiceDate) {
              return null;
            }
            let date = moment(item.invoiceDate, 'YYYYMMDD');
            return date.format('DD - MMM - YYYY');
          }
        },
        {
          label: LANG_CONST.doctors,
          sort: { sortKey: 'doctor' },
          resize: true,
          renderCell: (item) => {
            const partner = item.doctor;
            return partner && <ShortInfo user={partner} to={permissions.profilePath(partner)} />;
          }
        },
        {
          label: LANG_CONST.status,
          resize: true,
          width: `${remCss(110)}px`,
          sort: { sortKey: 'status' },
          renderCell: (item) => (
            <button className={'mc-status-' + item.status}>{upperFirstChar(item.status)}</button>
          )
        },
        {
          label: LANG_CONST.amount,
          sort: { sortKey: 'amount' },
          resize: true,
          width: `${remCss(160)}px`,
          renderCell: (item) => `${number.format(item.amount || 0)} ${item.currency}`
        },
        !medium && {
          label: LANG_CONST.actions,
          width: `${remCss(245)}px`,
          cellStyles: { textAlign: 'end' },
          renderCell: this.returnActions
        }
      ];
    return (
      <div className={'mc-container-content mc-appointment'}>
        <div className={'mc-container-content__header mc-flex-20'}>
          <span className={'mc-grow'}>{lang.t(LANG_CONST.titles.invoices)}</span>
          <SearchTextField
            width={300}
            template={'2'}
            onChange={(text) => {
              model.setStateSilent({
                pageIndex: 0
              });
              model.setListStateSilent({ items: [], total: 0 }, 'search');
              model.handleChangeSearch(text);
              if (!text) {
                model.setListState({ items: [] }, model.getCurrentId(), null, true);
                model.refresh();
              }
            }}
            value={model.listInput('search')}
          />
          <DatePickerField
            style={{ maxWidth: remCss(200) }}
            styleBox={{ backgroundColor: 'white' }}
            template={'6'}
            icontype={2}
            placeholder={LANG_CONST.invoice_date}
            placement={'bottom-center'}
            name={'searchDate'}
            value={model.input('searchDate')}
            onChange={(n, v) => {
              if (v.toString() === model.input('searchDate').toString()) return;
              model.setStateSilent({
                pageIndex: 0,
                searchDate: v
              });
              model.setListState({ items: [], total: 0 }, model.getCurrentId(), null, true);
              model.refresh();
            }}
            invalid={{}}
          />
          {ACTIONS.INVOICE_ADD_BUTTON.isActive && (
            <MCButton
              light
              primary
              radius
              medium
              style={{ height: remCss(50) }}
              onClick={() => {
                popupModel.setActivePopup(ACTIONS.INVOICE_ADD_BUTTON.key, {
                  active: true,
                  component: AddInvoice
                });
              }}
            >
              {lang.t(LANG_CONST.buttons.add_invoice)}
            </MCButton>
          )}
        </div>
        <div className={'mc-container-content__body'}>
          <div className={'mc-container-content__body-content'} style={{ marginTop: remCss(25) }}>
            <TableLibrary
              loading={loading}
              data={items}
              sortBy={model.state.sortBy}
              selectedPage={model.state.pageIndex}
              onSortChange={(sortBy) => {
                model.handleChange('sortBy', sortBy);
                model.setListState({ items: [] }, model.getCurrentId(), null, true);
                model.loadMore();
              }}
              onSetPage={(v) => {
                model.handleChange('pageIndex', v);
                model.setListState({ items: [] }, model.getCurrentId(), null, true);
                model.loadMore();
              }}
              columns={columns.filter((c) => !!c)}
              total={total}
              limit={model.listLimit}
              noResults={noResults}
              searchQuery={searchQuery}
              key={medium ? 1 : 0}
              className={medium ? 'mc-row2' : ''}
              renderExtend={medium && this.returnActions}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Invoices);
